import React from "react";
import "./footer.css";
const Footer = () => {
  const date = new Date()
  return (
    <footer className="flex">
      <ul className="flex">
        <li>
          <a href="#aboute">About</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
        <li>
          <a href="#skils">Skils</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <p>{date.getFullYear()} Spencer Sharp. All rights reserved &copy;</p>
    </footer>
  );
};

export default Footer;
